document.addEventListener("alpine:init", () => {
  Alpine.data("modalGalleryRail", () => ({
    showMaterialOther: false,
    shelves: [
      {
        length: "",
        depth: "",
        thickness: "",
        unit: "mm",
        quantity: null,
      },
    ],
    errors: [],

    init() {
      const submitButton = this.$refs.submitButton;

      submitButton.addEventListener("click", (e) => {
        e.preventDefault();

        this.errors = [];
        this.validate();

        if (this.errors.length === 0) {
          this.$refs.form.submit();
        }
      });
    },

    validate() {
      let children = this.$refs.form.querySelectorAll(
        "input, textarea, select"
      );
      let findEmpty = Array.from(children).find((element) => {
        if (element.required && element.value.trim().length < 1) {
          return true;
        }
        return false;
      });

      if (findEmpty) {
        this.errors.push({ message: "Fields marked with * are required" });
      }

      if (this.showMaterialOther) {
        const materialOtherField = this.$refs.form.querySelector(
          "input[name='contact[material_other]']"
        );
        if (!materialOtherField || !materialOtherField.value) {
          this.errors.push({ message: "Fields marked with * are required" });
        }
      }

      // this.shelves.forEach((shelf, index) => {
      //   if (!shelf.length)
      //     this.errors.push({
      //   message: `Shelf (${index + 1}) length is required`,
      //     });
      //   if (!shelf.depth)
      //     this.errors.push({
      //   message: `Shelf (${index + 1}) depth is required`,
      //     });
      //   if (!shelf.thickness)
      //     this.errors.push({
      //   message: `Shelf (${index + 1}) thickness is required`,
      //     });
      //   if (!shelf.unit)
      //     this.errors.push({
      //   message: `Shelf (${index + 1}) unit is required`,
      //     });
      //   if (!shelf.quantity)
      //     this.errors.push({
      //   message: `Shelf (${index + 1}) quantity is required`,
      //     });
      // });

      // if (this.showMaterialOther) {
      //   const materialOtherField = this.$refs.form.querySelector(
      //     "input[name='contact[material_other]']"
      //   );
      //   if (!materialOtherField || !materialOtherField.value) {
      //     this.errors.push({ message: "Please specify the material" });
      //   }
      // }
    },

    addShelf() {
      this.shelves.push({
        length: "",
        depth: "",
        thickness: "",
        unit: "mm",
        quantity: null,
      });
    },

    removeShelf(index) {
      this.shelves.splice(index, 1);
    },
  }));
});
